import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';

export const StContainer = styled(Grid)(({ theme }) => {
  const neutral0 = theme.palette.neutral0.main;
  const themeColor = theme.palette.themeColor.main;
  const themeColorSecondary = theme.palette.themeColorSecondary.main;
  return {
    [theme.breakpoints.down('lg')]: {
      backgroundImage: 'none',
    },
    [theme.breakpoints.up('lg')]: {
      backgroundImage: `linear-gradient(to top, ${neutral0} 70%, ${themeColorSecondary} 80%, ${themeColor})`,
    },
    [theme.breakpoints.up('xl')]: {
      backgroundImage: `linear-gradient(to top, ${neutral0} 60%, ${themeColorSecondary} 80%, ${themeColor})`,
    },
  };
});

export const StAboutWrapContainer = styled(Grid)(({ theme }) => ({
  maxWidth: '1302px',
  padding: '2rem',
  width: '100%',
  backgroundColor: theme.palette.neutral0.main,
  margin: '0 auto',
  [theme.breakpoints.up('lg')]: {
    margin: '32px',
    borderRadius: '16px',
    border: `1px solid ${theme.palette.neutral4.main}`,
  },
  [theme.breakpoints.up(1300)]: {
    margin: '32px auto',
  },
  [theme.breakpoints.down('sm')]: {
    padding: '16px',
  },
}));

export const StDropDown = styled(Grid)(() => ({
  '& .MuiSelect-select': {
    whiteSpace: 'normal !important',
  },
}));
